export function getApiOrigin(): string {
  const { origin } = window.location;

  if (origin.includes('localhost') || origin.includes('.corp.')) {
    return 'https://journey.pushwoosh.com';
  }

  return origin.replace('app.', 'journey.');
}
